import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from './layouts/Auth'
import MainLayout from './layouts/Main'
import store from './store'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  // mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: 'dashboard/alpha',
      component: MainLayout,
      meta: {
        authRequired: true,
        hidden: true,
      },
      children: [
        // Franchises
        {
          path: '/concesionarios/getFranchises',
          name: 'getConcesionarios',
          meta: {
            title: 'Conductores',
          },
          component: () => import('./views/franchises/getFranchises'),
        },
        {
          path: '/concesionarios/postFranchises',
          name: 'postConcesionarios',
          meta: {
            title: 'Concesionarios',
          },
          component: () => import('./views/franchises/postFranchises'),
        },
        {
          path: '/concesionarios/pagos',
          name: 'historialPagos',
          meta: {
            title: 'Historial de pagos',
          },
          component: () => import('./views/franchises/paymentHistory'),
        },
        {
          path: '/concesionarios/update',
          name: 'updateConcesionarios',
          meta: {
            title: 'Concesionarios',
          },
          component: () => import('./views/franchises/updateFranchise'),
        },
        {
          path: '/concesionarios/registrar',
          name: 'registerConcesionarios',
          meta: {
            title: 'Concesionarios',
          },
          component: () => import('./views/franchises/createFranchise'),
        },
        {
          path: '/concesionarios/postFranchisesPayments',
          name: 'postFranchisesPayments',
          meta: {
            title: 'AgregarPagosConcesionarios',
          },
          component: () => import('./views/franchises/postFranchisesPayments'),
        },
        {
          path: '/concesionarios/getFranchisesPayments',
          name: 'getFranchisesPayments',
          meta: {
            title: 'ConsultarPagosConcesionarios',
          },
          component: () => import('./views/franchises/getFranchisesPayments'),
        },
        {
          path: '/concesionarios/getFranchisesWithoutTrips',
          name: 'getFranchisesWithoutTrips',
          meta: {
            title: 'getFranchisesWithOutTrips',
          },
          component: () => import('./views/franchises/getFranchisesWithoutTrips'),
        },
        // Portal
        {
          path: '/portal/usuarios',
          name: 'getPortalUsers',
          meta: {
            title: 'Usuarios Concesionarios',
          },
          component: () => import('./views/franchiseAdmin/getFranchisesAdmin'),
        },
        {
          path: '/portal/usuarios/editarEmail',
          name: 'updateEmailPortalUsers',
          meta: {
            title: 'Edición Email Usuario',
          },
          component: () => import('./views/franchiseAdmin/getFranchisesAdmin/editEmail'),
        },
        {
          path: '/portal/registrar',
          name: 'postPortalUsers',
          meta: {
            title: 'Registrar Usuario Concesionario',
          },
          component: () => import('./views/franchiseAdmin/postFranchiseAdmin'),
        },
        // Concesiones
        {
          path: '/concessions/postConcessions',
          name: 'postConcesiones',
          meta: {
            title: 'Concesiones',
          },
          component: () => import('./views/concessions/postConcessions'),
        },
        {
          path: '/concessions/editarConcesion',
          name: 'updateConcesion',
          meta: {
            title: 'Editar Concesione',
          },
          component: () => import('./views/concessions/updateConcesion'),
        },
        {
          path: '/concessions/getConcessions',
          name: 'getConcesiones',
          meta: {
            title: 'Concesiones',
          },
          component: () => import('./views/concessions/getConcessions'),
        },
        {
          path: '/concessions/postPayments',
          name: 'postPayments',
          meta: {
            title: 'Concesiones',
          },
          component: () => import('./views/concessions/postPayments'),
        },
        {
          path: '/concessions/updatePayments',
          name: 'updatePayments',
          meta: {
            title: 'Concesiones',
          },
          component: () => import('./views/concessions/updatePayments'),
        },
        // Taximeters
        {
          path: '/taximeters/postTaximeters',
          name: 'postTaximeters',
          meta: {
            title: 'Taximetros',
          },
          component: () => import('./views/taximeters/postTaximeters'),
        },
        {
          path: '/taximeters/getTaximeters',
          name: 'getTaximeters',
          meta: {
            title: 'Taxímetros',
          },
          component: () => import('./views/taximeters/getTaximeters'),
        },
        // Vehicles Types
        {
          path: '/vehiculos/postVehiclesTypes',
          name: 'postVehiclesTypes',
          meta: {
            title: 'Tipos de Vehículos',
          },
          component: () => import('./views/vehicles/postVehiclesTypes'),
        },
        {
          path: '/vehiculos/getVehiclesTypes',
          name: 'getVehiclesTypes',
          meta: {
            title: 'Tipos de Vehículos',
          },
          component: () => import('./views/vehicles/getVehiclesTypes'),
        },
        // Vehicles
        {
          path: '/vehiculos/getVehicles',
          name: 'getVehicles',
          meta: {
            title: 'Vehicles',
          },
          component: () => import('./views/vehicles/getVehicles'),
        },
        {
          path: '/vehiculos/postVehicles',
          name: 'postVehicles',
          meta: {
            title: 'Vehicles',
          },
          component: () => import('./views/vehicles/postVehicles'),
        },
        // Drivers
        {
          path: '/conductores/getDrivers',
          name: 'getDrivers',
          meta: {
            title: 'Drivers',
          },
          component: () => import('./views/drivers/getDrivers'),
        },
        {
          path: '/conductores/postDrivers',
          name: 'postDrivers',
          meta: {
            title: 'Drivers',
          },
          component: () => import('./views/drivers/postDrivers'),
        },
        {
          path: '/conductores/registrar',
          name: 'createDriver',
          meta: {
            title: 'Drivers',
          },
          component: () => import('./views/drivers/createDriver'),
        },
        {
          path: '/conductores/updateDriver/:id',
          name: 'updateDriver',
          meta: {
            title: 'Drivers',
          },
          component: () => import('./views/drivers/updateDriver'),
        },
        {
          path: '/conductores/disableDriver',
          name: 'disableDriver',
          meta: {
            title: 'Deshabilitar conductor',
          },
          component: () => import('./views/drivers/disableDriver'),
        },
        {
          path: '/conductores/getDriversCheckIn',
          name: 'getDriversCheckIn',
          meta: {
            title: 'Drivers',
          },
          component: () => import('./views/drivers/getDriversCheckIn'),
        },
        // Trips
        {
          path: '/trips/getTrips',
          name: 'getTrips',
          meta: {
            title: 'Trips',
          },
          component: () => import('./views/trips/getTrips'),
        },
        // Administradores
        {
          path: '/admin/registrar',
          meta: {
            title: 'Registrar Administrador',
          },
          component: () => import('./views/admin/admin/register'),
        },
        {
          path: '/admin/administradores',
          meta: {
            title: 'Administradores',
          },
          component: () => import('./views/admin/users/users'),
        },
        {
          name: 'admin-info',
          path: '/admin/administrador/:id',
          meta: {
            title: 'Administrador',
          },
          component: () => import('./views/admin/user/user'),
        },
        {
          name: 'admin-map',
          path: '/admin/mapa',
          meta: {
            title: 'Mapa',
          },
          component: () => import('./views/admin/map/index'),
        },
        {
          name: 'pasajerosPreferentes',
          path: '/pasajerosPreferentes',
          meta: {
            title: 'PasajerosPreferentes',
          },
          component: () => import('./views/passengers/passengers/preferential'),
        },
        {
          name: 'pasajeros',
          path: '/pasajeros',
          meta: {
            title: 'Pasajeros',
          },
          component: () => import('./views/passengers/passengers/index'),
        },
        {
          name: 'cargaLayout',
          path: '/usuarios-preferentes',
          meta: {
            title: 'Usuaros Preferentes',
          },
          component: () => import('./views/passengers/passengers/layoutPassengers/index'),
        },
        {
          name: 'renta',
          path: '/renta/registrar',
          meta: {
            title: 'Registrar pagos',
          },
          component: () => import('./views/payments/registerPayment/'),
        },
        // Monedero
        {
          path: '/monedero/movesHistory',
          meta: {
            title: '',
          },
          component: () => import('./views/pocketMoney/movesHistory'),
        },
        {
          path: '/monedero/refunds',
          meta: {
            title: '',
          },
          component: () => import('./views/pocketMoney/refunds'),
        },
        // Sitios
        {
          path: '/sitios/sitios',
          name: 'GetSites',
          meta: {
            title: '',
          },
          component: () => import('./views/sites/getSites'),
        },
        {
          path: '/sitios/registrar-sitios',
          meta: {
            title: '',
          },
          component: () => import('./views/sites/postSite'),
        },
        {
          path: '/sitios/editarSitio',
          name: 'UpdateSite',
          meta: {
            title: 'Editar sitio',
          },
          component: () => import('./views/sites/updateSite'),
        },
        {
          path: '/sitios/editarSitio',
          name: 'ViewSite',
          meta: {
            title: 'Ver sitio',
          },
          component: () => import('./views/sites/ViewSite'),
        },
        // Dashboards
        {
          path: '/dashboard/alpha',
          meta: {
            title: '',
          },
          component: () => import('./views/dashboard/alpha'),
        },
        {
          path: '/historialPagos/concesionarios',
          meta: {
            title: 'Historial de pagos',
          },
          component: () => import('./views/paymentHistory/getFranchises'),
        },
        {
          path: '/historialPagos/pagos',
          name: 'paymentHistory',
          meta: {
            title: 'pagos',
          },
          component: () => import('./views/paymentHistory/paymentHistory'),
        },
        {
          path: '/montos/crearTarifa',
          name: 'createFare',
          meta: {
            title: 'Crear Tarifa',
          },
          component: () => import('./views/amounts/fares/createFare'),
        },
        {
          path: '/montos/tarifaBaseMunicipios',
          name: 'municipalityFare',
          meta: {
            title: 'Historial Tarifas Base',
          },
          component: () => import('./views/amounts/fares/municipalityFare'),
        },
        {
          path: '/montos/saldoMinimo',
          name: 'minBalance',
          meta: {
            title: 'Saldo minimo de monedero',
          },
          component: () => import('./views/amounts/fares/minimum-balance'),
        },
        {
          path: '/montos/TarifasTipoVehiculo',
          // name: 'updateVehicleFare',
          meta: {
            title: 'Crear Tarifa',
          },
          component: () => import('./views/amounts/fares/vehiclesTypesFares'),
        },
        {
          path: '/montos/editarTarifaTipoVehiculo',
          name: 'updateVehicleFare',
          meta: {
            title: 'Editar Tarifa',
          },
          component: () => import('./views/amounts/fares/updateVehicleTypeFare'),
        },
        {
          path: '/admin/registrarRol',
          meta: {
            title: 'Dashboard Alpha',
          },
          component: () => import('./views/admin/roles/registerRole'),
        },
        {
          path: '/admin/roles',
          meta: {
            title: 'Roles',
          },
          component: () => import('./views/admin/roles/getRoles'),
        },
        {
          path: '/admin/editarRole',
          name: 'updateRole',
          meta: {
            title: 'Editar Rol',
          },
          component: () => import('./views/admin/roles/updateRole'),
        },
        {
          path: '/emergencias/chofer',
          name: 'EmergencyDriver',
          meta: {
            title: 'Alertas Choferes',
          },
          component: () => import('./views/emergencies/drivers'),
        },
        {
          path: '/emergencias/pasajero',
          name: 'EmergencyPassenger',
          meta: {
            title: 'Alertas Pasajeros',
          },
          component: () => import('./views/emergencies/passengers'),
        },
        {
          path: '/geocercas/registrar',
          name: 'RegisterGeofences',
          meta: {
            title: 'Registrar GeoCerca',
          },
          component: () => import('./views/geofences/registerGeofences'),
        },
        {
          path: '/geocercas/geocercas',
          name: 'GetGeofences',
          meta: {
            title: 'Registrar GeoCerca',
          },
          component: () => import('./views/geofences/getGeofences'),
        },
        {
          path: '/geocercas/geocerca',
          name: 'ViewGeofences',
          meta: {
            title: 'Ver GeoCerca',
          },
          component: () => import('./views/geofences/viewGeofence'),
        },
        {
          path: '/geocercas/editarGeocerca',
          name: 'UpdateGeofences',
          meta: {
            title: 'Ver GeoCerca',
          },
          component: () => import('./views/geofences/updateGeofence'),
        },
        // Tarifas Planas
        {
          path: '/tarifasPlanas/registrarDestino',
          name: 'registerDestination',
          meta: {
            title: 'Registrar Destino',
          },
          component: () => import('./views/fixedFares/registerDestiny'),
        },
        {
          path: '/tarifasPlanas/destinos',
          name: 'getDestinations',
          meta: {
            title: 'Destinos',
          },
          component: () => import('./views/fixedFares/getDestinations'),
        },
        {
          path: '/tarifasPlanas/editarDestino',
          name: 'EditDestination',
          meta: {
            title: 'Editar Destino',
          },
          component: () => import('./views/fixedFares/updateDestination'),
        },
        {
          path: '/tarifasPlanas/registrar',
          name: 'registerFixedFare',
          meta: {
            title: 'Registrar tarifa plana',
          },
          component: () => import('./views/fixedFares/registerFixedFare'),
        },
        {
          path: '/tarifasPlanas/registrarTarifaPlana',
          name: 'registerRushHour',
          meta: {
            title: 'Registrar hora pico',
          },
          component: () => import('./views/fixedFares/registerRushHour'),
        },
        {
          path: '/tarifasPlanas/tarifasPlanas',
          name: 'getFixedFares',
          meta: {
            title: 'Tarifas planas',
          },
          component: () => import('./views/fixedFares/getFixedFares'),
        },
        {
          path: '/tarifasPlanas/editar',
          name: 'updateFixedFares',
          meta: {
            title: 'Editar tarifa',
          },
          component: () => import('./views/fixedFares/updateFixedFare'),
        },
        {
          path: '/tarifasPlanas/origen',
          name: 'getAllSources',
          meta: {
            title: 'Origen',
          },
          component: () => import('./views/fixedFares/getAllSources'),
        },
        {
          path: '/tarifasPlanas/registrarOrigen',
          name: 'registerOrigin',
          meta: {
            title: 'Registrar origen',
          },
          component: () => import('./views/fixedFares/createSource'),
        },
        {
          path: '/tarifasPlanas/editarOrigen',
          name: 'editOrigin',
          meta: {
            title: 'Editar origen',
          },
          component: () => import('./views/fixedFares/updateSource'),
        },
        {
          path: '/concesiones/deshabilitar',
          name: 'disableConcesion',
          meta: {
            title: 'Deshabilitar Concesion',
          },
          component: () => import('./views/concessions/disableConcesion'),
        },
        {
          path: '/concesiones/suspender',
          name: 'suspenderConcesion',
          meta: {
            title: 'Suspender Concesion',
          },
          component: () => import('./views/concessions/suspenderConcesion'),
        },
        {
          path: '/admin/deshabilitar',
          name: 'disableAdmin',
          meta: {
            title: 'Deshabilitar Administrador',
          },
          component: () => import('./views/admin/disableAdmin'),
        },
      ],
    },

    // System Pages
    {
      path: '/auth',
      component: AuthLayout,
      redirect: 'auth/login',
      children: [
        {
          path: '/auth/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/auth/404'),
        },
        {
          path: '/auth/500',
          meta: {
            title: 'Error 500',
          },
          component: () => import('./views/auth/500'),
        },
        {
          path: '/auth/login',
          meta: {
            title: 'Sign In',
          },
          component: () => import('./views/auth/login'),
        },
        {
          path: '/auth/register',
          meta: {
            title: 'Sign Up',
          },
          component: () => import('./views/auth/register'),
        },
        {
          path: '/auth/forgot-password',
          meta: {
            title: 'Forgot Password',
          },
          component: () => import('./views/auth/forgot-password'),
        },
        {
          path: '/auth/lockscreen',
          meta: {
            title: 'Lockscreen',
          },
          component: () => import('./views/auth/lockscreen'),
        },
      ],
    },

    // Redirect to 404
    {
      path: '*', redirect: 'auth/404', hidden: true,
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.state.user.authorized) {
      next({
        path: '/auth/login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
